// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"0c9ac7f4","418":"7861eae4","661":"7b815e22"}[chunkId] + ".chunk.js";
};